import {FORM_TYPE_TO_INPUT_FIELD_MAPPING} from './constants'

export const getInputName = (formType: string, inputType: string): string | undefined =>
  FORM_TYPE_TO_INPUT_FIELD_MAPPING[formType]?.[inputType]
